import s from './BurgerMenu.module.scss';
import {Link} from '@/i18n/routing';
import {
    LANGUAGES_DROPDOWN_MENU_LIST,
    TOP_HEADER_CONTENT
} from "../../../constants/header";
import {Accordion} from "@/app/[locale]/common/components/Accordion/Accordion";
import {useEffect, useState} from "react";
import {TTrigger} from "@/app/[locale]/common/components/Header/types";
import {PhoneIcon} from "@/app/[locale]/common/assets/PhoneIcon/PhoneIcon";
import {EmailIcon} from "@/app/[locale]/common/assets/EmailIcon/EmailIcon";
import {APP_ROUTES} from "../../../constants/app";
import {LanguageToggleIcon} from "@/app/[locale]/common/assets/LanguageToggleIcon/LanguageToggleIcon";
import {
    LanguageSelectionDropDownMenu
} from "@/app/[locale]/common/components/LanguageSelectionDropDownMenu/LanguageSelectionDropDownMenu";
import {useLocale, useTranslations} from "next-intl";
import {
    getLanguageAbbreviation
} from "@/app/[locale]/common/utils/functions/getLanguageAbbreviation/getLanguageAbbreviation";
import {CONTACT_INFO} from "@/app/[locale]/common/constants/main";

export const BurgerMenu = () => {
    const t = useTranslations('Header');

    useEffect(() => {
        document.body.classList.add("no-scroll");

        return () => document.body.classList.remove("no-scroll");
    }, []);

    const [ isOpen, setIsOpen ] = useState({
        'industries': false,
        'products': false,
        'solutions': false,
        'services': false,
        'languageSelection': false,
    });

    const locale = useLocale();
    const currentLanguage = getLanguageAbbreviation(locale);

    const handleOpen = (type: TTrigger) => {
        setIsOpen({
            ...isOpen,
            [type]: true,
        });
    };

    const handleClose = (type: TTrigger) => {
        setIsOpen({
            ...isOpen,
            [type]: false,
        });
    };

    return (
        <div className={s.burgerMenu}>
            <div className={s.burgerMenu_container}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <Link href={APP_ROUTES.ABOUT_US} className={s.burgerMenu_link}>{ t('aboutUs.title') }</Link>
                    <Accordion
                        isOpen={isOpen.industries}
                        trigger={t('industries.title')}
                        list={[{ title: t('burgerMenu.industries'), href: APP_ROUTES.INDUSTRIES }, ...t.raw('industries.list')]}
                        className={isOpen.industries ? s.burgerMenu_accordionActive : s.burgerMenu_accordion}
                        handleOpen={() => handleOpen('industries')}
                        handleClose={() => handleClose('industries')}
                    />
                    {/*<Accordion
                        isOpen={isOpen.products}
                        trigger={t('products.title')}
                        list={[{ title: t('burgerMenu.products'), href: APP_ROUTES.PRODUCTS }, ...t.raw('products.list')]}
                        className={isOpen.products ? s.burgerMenu_accordionActive : s.burgerMenu_accordion}
                        handleOpen={() => handleOpen('products')}
                        handleClose={() => handleClose('products')}
                    />*/}
                    <Accordion
                        isOpen={isOpen.solutions}
                        trigger={t('solutions.title')}
                        list={[{ title: t('burgerMenu.solutions'), href: APP_ROUTES.SOLUTIONS }, ...t.raw('solutions.list')]}
                        className={isOpen.solutions ? s.burgerMenu_accordionActive : s.burgerMenu_accordion}
                        handleOpen={() => handleOpen('solutions')}
                        handleClose={() => handleClose('solutions')}
                    />
                    <Accordion
                        isOpen={isOpen.services}
                        trigger={t('services.title')}
                        list={[{ title: t('burgerMenu.services'), href: APP_ROUTES.SERVICES }, ...t.raw('services.list')]}
                        className={isOpen.services ? s.burgerMenu_accordionActive : s.burgerMenu_accordion}
                        handleOpen={() => handleOpen('services')}
                        handleClose={() => handleClose('services')}
                    />
                    <Link href={APP_ROUTES.PLATFORM} className={s.burgerMenu_link}>{ 'Platform' }</Link>
                    <Link href={APP_ROUTES.PROJECTS} className={s.burgerMenu_link}>{ t('projects.title') }</Link>
                    <Link href={APP_ROUTES.NEWS} className={s.burgerMenu_link}>{ t('news.title') }</Link>
                    <Link href={APP_ROUTES.CONTACTS} className={s.burgerMenu_link}>{ t('contacts.title') }</Link>
                </div>

                <div className={s.burgerMenu_contacts}>
                    <LanguageSelectionDropDownMenu
                        isOpen={isOpen.languageSelection}
                        trigger={currentLanguage}
                        list={LANGUAGES_DROPDOWN_MENU_LIST}
                        Icon={<LanguageToggleIcon color={'black'}/>}
                        topPaddingContent={'topPaddingSmall'}
                        className={s.language}
                        handleOpen={() => handleOpen('languageSelection')}
                        handleClose={() => handleClose('languageSelection')}
                    />
                    <label>Contact us</label>
                    <Link
                        href={'tel:+639985509738'}
                        className={s.burgerMenu_contacts_link}
                    >
                        <PhoneIcon color={'black'}/> {TOP_HEADER_CONTENT.phoneNumber}
                    </Link>

                    <Link
                        href={`mailto:${CONTACT_INFO.EMAIL}`}
                        className={s.burgerMenu_contacts_link}
                    >
                        <EmailIcon color={'black'}/> {TOP_HEADER_CONTENT.email}
                    </Link>
                </div>
            </div>
        </div>
    );
};